import { useInfiniteQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import { Procedure } from '../types'

interface ProceduresListResponse {
  success: boolean
  result: Procedure[]
  count: number
}

interface UseProceduresListParams {
  residentId: string
  limit?: number
}

interface UseProceduresListReturn {
  procedures: Procedure[]
  isLoading: boolean
  refetch: () => void
  fetchNextPage: () => void
  hasNextPage: boolean
  isFetchingNextPage: boolean
}

export const useProceduresList = ({
  residentId,
  limit = 50
}: UseProceduresListParams): UseProceduresListReturn => {
  const fetchProcedures = async ({ pageParam = 0 }) => {
    const url = `/api/list/procedures?resident=${residentId}&limit=${limit}&offset=${pageParam}`

    const response = (await getJSON({ url })) as ProceduresListResponse

    return {
      procedures: response.result || [],
      totalCount: response.count || 0,
      nextOffset:
        response.result?.length === limit ? pageParam + limit : undefined
    }
  }

  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch
  } = useInfiniteQuery(['procedures', residentId], fetchProcedures, {
    getNextPageParam: (lastPage) => lastPage.nextOffset,
    enabled: !!residentId
  })

  const procedures = data?.pages.flatMap((page) => page.procedures) || []

  return {
    procedures,
    isLoading,
    refetch,
    fetchNextPage,
    hasNextPage: !!hasNextPage,
    isFetchingNextPage
  }
}
